export default class GetAllOrdersDTO {
  constructor(public account_id: ID) {}
}
